import { Person } from '@fs/zion-person'
import { type BasePerson } from '@fs/zion-tree-types'
import React, { type ReactNode, type ComponentProps } from 'react'
import PersonCreatedDate from './PersonCreatedDate'
import PersonTextAlignmentDecorator from '../common/PersonTextAlignmentDecorator'
import { type AnalysisFullPerson } from '../analysis/types'

type PersonTextAlignmentDecoratorMdProps = {
  children: ReactNode
}

function PersonTextAlignmentDecoratorMd({ children }: PersonTextAlignmentDecoratorMdProps): JSX.Element {
  return <PersonTextAlignmentDecorator avatarSize={40}>{children}</PersonTextAlignmentDecorator>
}

type Props = Omit<ComponentProps<typeof Person>, 'personObj' | 'isMobileOrientation'> & {
  personObj: Partial<BasePerson> | Partial<AnalysisFullPerson> | undefined
  isMobileOrientation: boolean
}

export default function PersonAndDateAdded({ personObj, isMobileOrientation, ...props }: Props): JSX.Element {
  const PersonCreatedDateWrapper = isMobileOrientation ? PersonTextAlignmentDecorator : PersonTextAlignmentDecoratorMd

  let creationDateMs: number | undefined
  if (personObj && 'creationDateMs' in personObj && typeof personObj.creationDateMs === 'number') {
    creationDateMs = personObj.creationDateMs
  } else if (personObj && 'initialCreationDateMs' in personObj && typeof personObj.initialCreationDateMs === 'number') {
    creationDateMs = personObj.initialCreationDateMs
  }

  return (
    <div>
      <Person personObj={personObj} {...props} />
      {creationDateMs && (
        <PersonCreatedDateWrapper>
          <PersonCreatedDate size="xs" secondary creationDateMs={creationDateMs} />
        </PersonCreatedDateWrapper>
      )}
    </div>
  )
}
